import React from 'react';
import MapComponent from './MapComponent';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './map.modules.css';

var MapRender = function MapRender(props) {
  var classes = useStyle(defaultClasses, props.classes);
  var coordinates = props.coordinates,
      newPosition = props.newPosition,
      setNewPosition = props.setNewPosition,
      showMarker = props.showMarker,
      radius = props.radius,
      isMarkerShown = props.isMarkerShown,
      storesNearby = props.storesNearby,
      shownStores = props.shownStores,
      setShownStores = props.setShownStores;
  var Map = React.createElement(MapComponent, {
    coordinates: coordinates,
    newPosition: newPosition.radius === '' ? {
      lat: newPosition.lat,
      lng: newPosition.lng,
      radius: {
        value: '100',
        zoom: 12
      }
    } : {
      lat: newPosition.lat,
      lng: newPosition.lng,
      radius: radius
    },
    setNewPosition: setNewPosition,
    showMarker: showMarker,
    isMarkerShown: isMarkerShown,
    stores: storesNearby,
    shownStores: shownStores,
    setShownStores: setShownStores,
    radius: radius
  });
  return React.createElement("div", {
    className: classes.root
  }, Map);
};

export default MapRender;